import { DatePicker, InputNumber, Select } from "antd";
import dayjs from "dayjs";
import SimpleTablePage from "../common/SimpleTablePage";
import DebounceSelect from "../common/DebounceSelect";
import { api } from "../common/api";
import { date2locale } from "../common/common";

const sources = {
  mansion: "Mansione",
  appointment: "Nomina",
  equipment: "Attrezzatura",
  dpi: "DPI",
};

const getDaysColor = (days) => {
  if (days == null || days < 0) return "red";
  if (days < 30) return "orange";
  return "blue";
};

const columns = [
  {
    title: "Dipendente",
    key: "employee",
    dataIndex: "employee",
    render: (employee) =>
      employee?.fullName ?? `${employee?.firstName ?? ""} ${employee?.lastName ?? ""}`,
    sorter: true,
    ellipsis: true,
    width: 250,
  },
  {
    title: "Categoria corso",
    key: "courseType",
    dataIndex: "courseType",
    render: (courseType) => courseType?.title,
    sorter: true,
    ellipsis: true,
    width: 250,
  },
  {
    title: "Origine",
    key: "source",
    dataIndex: "source",
    render: (source) => sources[source] ?? source,
    sorter: true,
    width: 150,
  },
  {
    title: "Scadenza",
    key: "dueDate",
    dataIndex: "dueDate",
    render: (date) => (date ? date2locale(date) : "-"),
    sorter: true,
    width: 150,
  },
  {
    title: "Giorni di ritardo/rimasti",
    key: "dates",
    ellipsis: true,
    dataIndex: "dueDate",
    render: (date) => {
      const daysLeft = date && dayjs(date).diff(dayjs().startOf("day"), "day")
      return <span style={{ color: getDaysColor(daysLeft) }}>{daysLeft ?? "MANCANTE"}</span>
    },
    width: 150,
  },
];

const entityFilter = (name, label, resource, getLabel) => ({
  name,
  label,
  readableValue: (value) => value && JSON.parse(value).label,
  formItem: {
    props: {
      getValueProps: (value) => ({ value: value && JSON.parse(value) }),
      normalize: (value) => value && JSON.stringify(value),
    },
    children: (
      <DebounceSelect
        allowClear
        minSize={0}
        fetchOptions={(query) =>
          api[resource]
            .list({ query, pageSize: 9999 })
            .then(({ data }) => data.map((item) => ({ label: getLabel(item), value: item.id })))
        }
      />
    ),
  },
});

const dateFilter = (name, label) => ({
  name,
  label,
  readableValue: date2locale,
  formItem: {
    props: {
      getValueProps: (value) => ({ value: value ? dayjs(value) : null }),
      normalize: (value) => value?.format("YYYY-MM-DD"),
    },
    children: <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />,
  },
});

const filterItems = [
  entityFilter("employee", "Dipendente", "employee", (employee) => employee.fullName),
  entityFilter("courseType", "Categoria corso", "courseType", (courseType) => courseType.title),
  {
    name: "source",
    label: "Origine",
    readableValue: (value) => sources[value] ?? value,
    formItem: {
      children: (
        <Select
          allowClear
          options={Object.entries(sources).map(([value, label]) => ({ value, label }))}
        />
      ),
    },
  },
  {
    name: "sourceId",
    label: "ID origine",
    formItem: { children: <InputNumber min={1} precision={0} style={{ width: "100%" }} /> },
  },
  dateFilter("startDueDate", "Scadenza dal"),
  dateFilter("endDueDate", "Scadenza al"),
];

const fetchCourses = (params) =>
  api.employeeRequiredCourse.list({
    ...params,
    employee: params.employee ? JSON.parse(params.employee).value : undefined,
    courseType: params.courseType ? JSON.parse(params.courseType).value : undefined,
  });

export default function EmployeeRequiredCourses() {
  return (
    <SimpleTablePage
      title="Corsi obbligatori"
      description="Consulta i corsi richiesti per i dipendenti e le relative scadenze"
      resource="employeeRequiredCourse"
      columns={columns}
      filterItems={filterItems}
      fetchFunction={fetchCourses}
      rowKey={(record) => {
        const key =
          record.employee.id +
          "" +
          record.courseType.id +
          "" +
          record.source +
          "" +
          record.sourceId;
        return key;
      }}
      searchQueryName={null}
    />
  );
}
